var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecipientsUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2096_30561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7334 18.1504H28.0266C28.3025 18.8842 28.4532 19.6761 28.4532 20.5014V30.4392C28.4532 30.7833 28.3916 31.1136 28.2794 31.4208H32.7543C34.4259 31.4208 35.7858 30.0997 35.7858 28.4759V23.0584C35.7858 20.3522 33.5193 18.1504 30.7334 18.1504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11823 20.5014C8.11823 19.676 8.26896 18.8842 8.54486 18.1504H5.8381C3.05217 18.1504 0.785645 20.3522 0.785645 23.0585V28.476C0.785645 30.0998 2.14552 31.4208 3.81712 31.4208H8.29207C8.17989 31.1135 8.11823 30.7833 8.11823 30.4392V20.5014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3797 15.5933H15.1916C12.4057 15.5933 10.1392 17.795 10.1392 20.5014V30.4391C10.1392 30.9811 10.5916 31.4207 11.1497 31.4207H25.4216C25.9797 31.4207 26.4321 30.9812 26.4321 30.4391V20.5014C26.4321 17.795 24.1656 15.5933 21.3797 15.5933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2857 2.5791C14.9352 2.5791 12.2095 5.22699 12.2095 8.48177C12.2095 10.6894 13.4638 12.6176 15.3162 13.6299C16.1948 14.11 17.2078 14.3844 18.2857 14.3844C19.3636 14.3844 20.3765 14.11 21.2551 13.6299C23.1076 12.6176 24.3619 10.6894 24.3619 8.48177C24.3619 5.22706 21.6361 2.5791 18.2857 2.5791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61598 8.08105C5.11026 8.08105 3.07178 10.0613 3.07178 12.4954C3.07178 14.9295 5.11026 16.9098 7.61598 16.9098C8.25158 16.9098 8.85684 16.7819 9.40665 16.552C10.3573 16.1544 11.1411 15.4506 11.6261 14.5691C11.9665 13.9504 12.1602 13.2445 12.1602 12.4954C12.1602 10.0614 10.1217 8.08105 7.61598 8.08105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9553 8.08105C26.4496 8.08105 24.4111 10.0613 24.4111 12.4954C24.4111 13.2446 24.6048 13.9504 24.9452 14.5691C25.4302 15.4507 26.214 16.1545 27.1647 16.552C27.7145 16.7819 28.3197 16.9098 28.9553 16.9098C31.461 16.9098 33.4995 14.9295 33.4995 12.4954C33.4995 10.0613 31.461 8.08105 28.9553 8.08105Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2096_30561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 34,
    fill: "white",
    transform: "translate(0.785645)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipientsUsers);
export default __webpack_public_path__ + "static/media/RecipientsUsers.d8bf67d95a38f0932eb095062fbd88d1.svg";
export { ForwardRef as ReactComponent };